var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Popups'),_c('AnswerPopups'),_c('keep-alive',{attrs:{"include":['AnswerAppView']}},[_c('router-view',{key:_vm.$route.path + _vm.$route.query.t})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }